import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';
import { CurriculumTreeYearQueries } from '.';
import {
  CurriculumTreeYearServiceInterface,
  CURRICULUM_TREE_YEAR_SERVICE_TOKEN,
} from '../../curriculum-tree-year/curriculum-tree-year.service.interface';
import { DalState } from '../dal.state.interface';
import {
  CurriculumTreeYearsActionTypes,
  CurriculumTreeYearsLoaded,
  CurriculumTreeYearsLoadError,
  LoadCurriculumTreeYears,
} from './curriculum-tree-year.actions';

@Injectable()
export class CurriculumTreeYearEffects {
  loadCurriculumTreeYears$ = createEffect(() =>
    this.actions.pipe(
      ofType(CurriculumTreeYearsActionTypes.LoadCurriculumTreeYears),
      concatLatestFrom(() => this.store.select(CurriculumTreeYearQueries.getLoaded)),
      fetch({
        run: (action: LoadCurriculumTreeYears, loaded: boolean) => {
          if (!action.payload.force && loaded) return;
          return this.curriculumTreeYearService
            .getAllForUser(action.payload.userId)
            .pipe(map((curriculumTreeYears) => new CurriculumTreeYearsLoaded({ curriculumTreeYears })));
        },
        onError: (action: LoadCurriculumTreeYears, error) => {
          return new CurriculumTreeYearsLoadError(error);
        },
      })
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<DalState>,
    @Inject(CURRICULUM_TREE_YEAR_SERVICE_TOKEN)
    private curriculumTreeYearService: CurriculumTreeYearServiceInterface
  ) {}
}
